export default __webpack_public_path__ + "static/media/lunchimage.7a9fffbf.jpg";